module.exports = __webpack_public_path__ + "img/business_license.9f9f379b.png";